import React from 'react'
import { Offcanvas } from 'react-bootstrap'
import UpdateRoomMaintenanceComponent from './UpdateRoomMaintenanceComponent'

interface UpdateRoomMaintenanceDialogProps {
    show: boolean,
    onClose: () => void,
    id: string
}

const UpdateRoomMaintenanceDialog: React.FC<UpdateRoomMaintenanceDialogProps> = ({ show, onClose, id }) => {
    const handleClose = () => {
        onClose()
    }

    return (
        <Offcanvas show={show} placement="end" onHide={handleClose} style={{ width: '100%' }}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Update Room Maintenance</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {/* <CreateRoomMaintenanceComponent onClose={handleClose} /> */}
                <UpdateRoomMaintenanceComponent onClose={handleClose} id={id} />
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default UpdateRoomMaintenanceDialog